import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const HrBrandScaleSmallKindDefault = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.00002 3.19389L9.61613 5.49915L9.71477 5.63986L9.87908 5.69019L12.5709 6.51484L10.8779 8.76422L10.7746 8.90152L10.7775 9.07334L10.825 11.8883L8.16253 10.9732L8.00002 10.9173L7.8375 10.9732L5.17505 11.8883L5.22258 9.07334L5.22548 8.90152L5.12214 8.76422L3.42912 6.51484L6.12095 5.69019L6.28526 5.63986L6.38391 5.49915L8.00002 3.19389Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <circle
                cx={6.72263}
                cy={6.49277}
                r={0.907806}
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <circle
                cx={9.25783}
                cy={6.4933}
                r={0.908343}
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <circle
                cx={9.96559}
                cy={8.72145}
                r={0.908343}
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <circle
                cx={6.10073}
                cy={8.72145}
                r={0.908343}
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <circle
                cx={8.00002}
                cy={10.1646}
                r={0.908343}
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Hr'
);
export default HrBrandScaleSmallKindDefault;
